import { Euler as r, Matrix4 as t, Vector3 as e } from "three";
import { Vectors as i } from "../utils/index36.js";
import { V3toVector3 as m } from "./index9.js";
const a = (o) => new r().setFromRotationMatrix(
  new t().lookAt(new e(), m(o).clone().negate(), i.Up)
);
export {
  a as dir2Euler
};
//# sourceMappingURL=index4.js.map
